export default __webpack_public_path__ + "static/media/advent-final.122fae21.png";